import { ADD_QUICK_SEARCH_RESULTS, ADD_GLOBAL_SEARCH_RESULTS } from '../types';

const INITIAL_STATE = {
    quick: [],
    global: []
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case ADD_QUICK_SEARCH_RESULTS:
            state.quick.unshift(action.payload);
            if (state.quick.length > 10) { //Maximum of 10 Cached Results
                state.quick = state.quick.slice(0, 9);
            }
            return { ...state }
        case ADD_GLOBAL_SEARCH_RESULTS:
            state.global.unshift(action.payload);
            if (state.global.length > 10) { //Maximum of 10 Cached Results
                state.global = state.global.slice(0, 9);
            }
            return { ...state }
        default:
            return state;
    }
}